import styled from 'styled-components'

const NotificationContainer = styled.div<{ $color?: string }>`
	display: flex;
	align-items: center;
	border-radius: 4px;
	padding: 12px 20px;
	background: ${({ $color }) => $color || '#f5f5f5'};
	color: ${({ $color }) => ($color ? '#fff' : '#222')};
	font-size: 1rem;
	gap: 12px;
`

const IconWrapper = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.5em;
`

type Props = {
	icon: React.ReactNode
	text?: string
	textNode?: React.ReactNode
	color?: string
	className?: string
	style?: React.CSSProperties
}

function InlineNotification({
	icon,
	text,
	textNode,
	color,
	className,
	style,
}: Props) {
	return (
		<NotificationContainer $color={color} className={className} style={style}>
			<IconWrapper>{icon}</IconWrapper>
			{text ? <span>{text}</span> : null}
			{textNode ? <span>{textNode}</span> : null}
		</NotificationContainer>
	)
}

export default InlineNotification
